import React, { ChangeEvent, useState } from 'react';
import FormWrapper from '../../../../Components/Form/FormWrapper';
import { useForm } from 'react-hook-form';
import SubmitButton from '../../../../Components/Button/SubmitButton';
import { DeepPartial } from '../../../../Interfaces/DeepPartial';
import styles from './CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm.module.scss';
import DateField from '../../../../Components/Form/components/DateField';
import TextAreaField from '../../../../Components/Form/components/TextAreaField';
import FileUpload from '../../../../Components/Base/FileUpload/FileUpload';
import FormControl from '../../../../Components/Form/FormControl';
import InputWrapper from '../../../../Components/Form/components/InputWrapper/InputWrapper';
import * as yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import CSSZAddressContainer from '../CSSZSickLeaveCertificateCreate/FormParts/CSSZAddressContainer';
import Text from '../../../../Components/Base/Text/Text';
import FormContainer from '../../../../Components/Form/FormContainer';
import { CSSZAddress } from '../../Interfaces/CSSZ.interface';
import SelectField from '../../../../Components/Form/components/SelectField';
import { SelectValue } from '../../../../Components/Base/Select/Select';
import { CSSZSickLeavePatientAddressValidationScheme } from '../../Validation/CSSZValidation';
import TermItemAsyncSelectField from '../../../Base/Components/Fields/TermItemAsyncSelect/TermItemAsyncSelectField';

export interface CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues {
	dateFrom: string;
	dateTo: string;
	requestReason: string;
	address: Omit<CSSZAddress, 'typeOfAddress'>;
	file?: File;
}

interface Props {
	onSubmit: (
		values: CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues,
	) => void;
	defaultValues?: DeepPartial<CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues>;
}

const validationSchema = yup.object({
	dateFrom: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.dateFrom',
		),
	dateTo: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.dateTo',
		),
	requestReason: yup
		.string()
		.nullable()
		.required(
			'validation.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.requestReason',
		),
	address: CSSZSickLeavePatientAddressValidationScheme,
});

const CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm: React.FC<
	Props
> = ({ onSubmit, defaultValues }) => {
	const [selectedFile, setSelectedFile] = useState<File | undefined>();
	const formMethods = useForm({
		defaultValues,
		resolver: yupResolver(validationSchema),
	});

	const handleChangeFile = (event: ChangeEvent<HTMLInputElement>) => {
		setSelectedFile(event.target.files?.[0]);
	};

	const handleSubmit = (
		values: CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryFormValues,
	) => {
		onSubmit({
			...values,
			file: selectedFile,
		});
	};

	return (
		<FormWrapper formMethods={formMethods}>
			<div className={styles.inline}>
				<DateField
					name='dateFrom'
					label='component.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.dateFrom'
					isRequired
					isWrapped
					isDisabled
				/>
				<DateField
					name='dateTo'
					label='component.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.dateTo'
					isRequired
					isWrapped
				/>
			</div>
			<TextAreaField
				name='requestReason'
				label='component.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.requestReason'
				isRequired
				isWrapped
			/>
			<Text
				tx='component.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.addressInOtherCountry'
				className={styles.bold}
			/>
			<FormContainer name='address'>
				<TermItemAsyncSelectField
					name='state'
					label='component.CSSZSickLeavePatientAddress.state'
					termType='cssz_ciselnik_zemi'
					isRequired
					isWrapped
				/>
				<CSSZAddressContainer />
			</FormContainer>
			<InputWrapper>
				<FormControl
					label='component.CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountry.file'
					name='file'
					onChange={handleChangeFile}
					isRequired>
					<FileUpload />
				</FormControl>
			</InputWrapper>
			<div className='mt-3'>
				<SubmitButton onSubmit={handleSubmit} />
			</div>
		</FormWrapper>
	);
};

export default CSSZSickLeaveCertificateRequestForChangeAddressBecauseBeingOutsideOfCountryForm;
